import EnterpriseGroupModel   from 'Models/directory/EnterpriseGroupModel';
import EnterpriseModel        from 'Models/directory/EnterpriseModel';
import PaymentModeModel       from 'Models/invoice/PaymentModeModel';
import TaxZoneModel           from 'Models/invoice/TaxZoneModel';
import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('InvoicingOwner')
@model.urnResource('invoicing_owner')
@doc.path('/invoicing_owners/{?id}')
export default class InvoicingOwnerModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'accountingCode': id;
		'enterpriseGroupUrn': Urn;
		'enterpriseUrn': Urn;
		'invoicingGroups.billingGroups.invoices.billingPeriod': id;
		'taxZone': id;
		'taxZone.code': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'accountingCode': string;
	}> = {};

	@doc.string declare accountingCode: string;
	@doc.modelUrn(EnterpriseGroupModel) declare enterpriseGroup: EnterpriseGroupModel;
	@doc.modelUrn(EnterpriseModel) declare enterprise: EnterpriseModel;
	@doc.model(PaymentModeModel) declare paymentMode: PaymentModeModel;
	@doc.model(TaxZoneModel) declare taxZone: TaxZoneModel;
}